import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { Button } from '../Button';
import { UserMenu } from '../UserMenu';

export const Navbar: React.FC = () => {
  const { isAuthenticated, isLoading, login } = useAuthContext();

  const navLinkClasses = ({ isActive }: { isActive: boolean }) =>
    `inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200 ${
      isActive
        ? 'border-primary-500 text-primary-600'
        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-900'
    }`;

  return (
    <header className="bg-white border-b border-gray-100">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-primary-600 font-bold text-xl">
              ForgeFair
            </Link>
            <div className="hidden sm:ml-8 sm:flex sm:space-x-8">
              <NavLink to="/projects" className={navLinkClasses}>
                Browse Projects
              </NavLink>
              <NavLink to="/sell-your-project" className={navLinkClasses}>
                Sell Your Project
              </NavLink>
              <NavLink to="/community" className={navLinkClasses}>
                Community
              </NavLink>
              <NavLink to="/blog" className={navLinkClasses}>
                Blog
              </NavLink>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {!isLoading && (
              <>
                {isAuthenticated ? (
                  <UserMenu />
                ) : (
                  <>
                    <Button variant="secondary" onClick={login}>
                      Login
                    </Button>
                    <Button className="ml-4" onClick={login}>
                      Join Community
                    </Button>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}; 